export enum EProjectStatus {
  Started = 0,

  Completed = 5,

  Closed = 10
}
